import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanLoad } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class BrowserOnlyGuard implements CanLoad {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  canLoad(): boolean {
    // Only allow loading in the browser
    return isPlatformBrowser(this.platformId);
  }
}
